<thm-notification></thm-notification>

<!--<aof-sayac [sure]="30000" [sayacAktifMi]="sayacCalisacakMi" (sureBitti)="sureBitti()"> </aof-sayac>-->
<!--sayacCalisacakMi-->
<thm-modal-trigger #oturumModal [title]="'Oturum Bilgisi'" [closable]="false">
  <p>Oturumunuz sona erdi.</p>

</thm-modal-trigger>

<thm-wrapper>
  <router-outlet></router-outlet>
</thm-wrapper>

<a class="aos-support" href="https://aosdestek.anadolu.edu.tr/" target="_blank">
  <span [innerHTML]="'giris.aosDestekUpper' | transloco"></span>
</a>